import Penpal from 'penpal';
import 'url-polyfill';

import { deviceIdKey } from './consts';

/** Executed inside iframe */
export type CrossSiteSyncMethods = {
  /** Get TOMIS device id from iframe local storage.
   *
   * Returns empty string if not found or if local storage
   * (in third-party context) is blocked by browser.
   */
  getDeviceIdIframeLocalStorage: () => Promise<string>;
  /** Set TOMIS device id to iframe local storage.
   *
   * Will catch error if local storage is blocked by browser.
   * @returns device id if successful, empty string if not.
   */
  setDeviceIdIframeLocalStorage: (id: string) => Promise<string>;
};

// expose methods to set/get device ID inside iframe
Penpal.connectToParent({
  methods: {
    async getDeviceIdIframeLocalStorage() {
      try {
        return localStorage.getItem(deviceIdKey) || '';
      } catch (error) {
        return '';
      }
    },
    async setDeviceIdIframeLocalStorage(id: string) {
      try {
        localStorage.setItem(deviceIdKey, id);
        return id;
      } catch (error) {
        return '';
      }
    },
  } as CrossSiteSyncMethods,
});
